import { liff } from '@line/liff';
import { LiffMockPlugin } from '@line/liff-mock';
import { env } from '~/env';

export const initLiffMock = async () => {
  liff.use(new LiffMockPlugin());

  await liff.init({
    liffId: env.VITE_LIFF_ID,
    withLoginOnExternalBrowser: true,
    mock: true,
  });

  if (!liff.isInClient()) liff.login();

  liff.$mock.set({
    getProfile: {
      userId: 'Udeadbeefdeadbeefdeadbeefdeadbeef',
      displayName: 'Mocked user',
      statusMessage: 'Mocked status message',
      pictureUrl: 'https://api.dicebear.com/9.x/thumbs/svg?seed=Sophia',
    },
    getFriendship: {
      friendFlag: true,
    },
    isLoggedIn: true,
  });
};
